<template>
    <div class="user-pp-gallery">
        <VideoLightBox ref="lightbox" :media="videoItems" :show-light-box="false"></VideoLightBox>
        <div class="gallery-title">
            <h5>Video</h5>
        </div>
        <div class="row">
            <div
                    v-for="(video, videoIndex) in videos"
                    :key="videoIndex"
                    @click="showVideo(videoIndex)"
                    class="col-lg-6 col-md-6 col-xl-3"
            >
                <div class="gallery-box">
                    <img :src="video.thumbnail" :alt="video.title"/>
                    <div v-if="video.task" class="gallery-box-title">
                        <h4>
                            {{ video.task.category.title }} in
                            {{ video.task.suburb.name }}
                        </h4>
                    </div>
                    <div v-else class="gallery-box-title">
                        <h4>{{ video.title }}</h4>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    // Import VueLightBox
    import VideoLightBox from '../dashboard/profile/VideoLightBox'
    require('vue-image-lightbox/dist/vue-image-lightbox.min.css')

    export default {
        components: {
            VideoLightBox
        },
        props: {
            videos: {
                type: [Array, Object],
                required: true
            }
        },
        data() {
            return {
                index: null,
                videoItems: []
            };
        },
        created() {
            let self = this;
            self.setVideoItems(self.videos);
        },
        methods:{
            setVideoItems: function(videos){
                let self = this;
                videos.forEach(function(video) {
                    let item = {};
                    item.thumb= video.thumbnail;
                    item.sources = [];
                    item.sources[0] = {};
                    item.sources[0].src = video.source;
                    item.sources[0].type = 'video/mp4';
                    item.type = 'video';
                    item.caption = '';
                    item.width = 800;
                    item.height = 600;
                    item.autoplay = false;
                    self.videoItems.push(item);
                });
            },
            showVideo(index) {
                if (this.videos.length) {
                    this.$refs.lightbox.showImage(index);
                }
            },
        }
    };
</script>
<style scoped></style>
